import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { reverseGeocode } from '@/lib/geocoder';
import { resolveGeocoderConfig } from '@/lib/geocoderConfig';

export default function useGeocodedAddress(latitude, longitude, fallbackAddress) {
  const userAttrs = useSelector((state) => state.session.user?.attributes);
  const orgSettings = useSelector((state) => state.org?.settings);
  // User pick → organization default (Settings → Organization → Address lookup) → none.
  const { provider, key: apiKey, language } = resolveGeocoderConfig(userAttrs, orgSettings);

  const [address, setAddress] = useState(fallbackAddress);
  const cancelRef = useRef(false);

  useEffect(() => {
    if (!provider) {
      setAddress(fallbackAddress);
      return;
    }

    if (!latitude || !longitude) {
      setAddress(fallbackAddress);
      return;
    }

    cancelRef.current = false;

    reverseGeocode(latitude, longitude, provider, apiKey, language)
      .then((result) => {
        if (!cancelRef.current) setAddress(result || fallbackAddress);
      })
      .catch(() => {
        if (!cancelRef.current) setAddress(fallbackAddress);
      });

    return () => { cancelRef.current = true; };
  }, [latitude, longitude, provider, apiKey, language, fallbackAddress]);

  return address;
}
